import React from 'react'
import MatchingHeaderLabels from '@Components/MatchComponents/MatchRecordingGroups/MatchRecordingGroupsHeader/MatchingHeaderLabels'

interface MatchRecordingGroupsHeaderProps {
    totalCount: number
    currentCount: number
    selectedCount: number
}

const MatchRecordingGroupsHeader = (props: MatchRecordingGroupsHeaderProps) => {
    const { totalCount, selectedCount, currentCount } = props

    return (
        <div className="results-header">
            <div className="results-count">
                {totalCount !== 0 && (
                    <p>{`Showing 1 - ${currentCount} of ${totalCount > 200 ? '200+' : totalCount} results`}</p>
                )}
            </div>
            {totalCount > 0 && <MatchingHeaderLabels selectedListLength={selectedCount} />}
        </div>
    )
}

export default MatchRecordingGroupsHeader
